import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

export const BuyOrSellBtn = styled(Button)({
  height: "40px",
  lineHeight: "40px",
  maxHeight: "40px",
  width: "120px",
  color: "rgba(0, 0, 0, 0.80)",
  fontSize: 14,
  fontFamily: "Gill Sans",
  textTransform: "uppercase",
  background: "#22D758",
  border: "none",
  borderRadius: "4px",
  "&:hover": {
    background: "#37FF73",
  },
});
